import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../../../components/ui/Button';
import CompanyStatusBadge from './CompanyStatusBadge';
import CompanyActionsMenu from './CompanyActionsMenu';
import CopyLinkButton from './CopyLinkButton';

const CompanyTableRow = ({ company, onStatusToggle, onDuplicate }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleOpenLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const visualizerUrl = `${window.location?.origin}/visualizer/${company?.slug}-${company?.id}`;
  const dashboardUrl = `${window.location?.origin}/client/${company?.slug}-${company?.id}`;
  const embedUrl = `${window.location?.origin}/embed/${company?.slug}-${company?.id}`;

  return (
    <tr className="data-table-row">
      <td className="data-table-cell">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary font-semibold">
            {company?.name?.charAt(0)?.toUpperCase()}
          </div>
          <div>
            <div className="font-medium text-text-primary">{company?.name}</div>
            <div className="text-xs text-text-secondary">{company?.slug}-{company?.id}</div>
          </div>
        </div>
      </td>
      <td className="data-table-cell">
        <CompanyStatusBadge status={company?.status} />
      </td>
      <td className="data-table-cell">
        <div className="text-sm text-text-primary">{formatDate(company?.createdAt)}</div>
        <div className="text-xs text-text-secondary">
          Updated {formatDate(company?.updatedAt)}
        </div>
      </td>
      <td className="data-table-cell">
        <div className="flex flex-wrap gap-2">
          <div className="flex items-center gap-1">
            <CopyLinkButton url={visualizerUrl} label="Visualizer" />
            <Button
              variant="ghost"
              size="xs"
              onClick={() => handleOpenLink(visualizerUrl)}
              iconName="ExternalLink"
              iconSize={12}
            />
          </div>
          <div className="flex items-center gap-1">
            <CopyLinkButton url={dashboardUrl} label="Dashboard" />
            <Button
              variant="ghost"
              size="xs"
              onClick={() => handleOpenLink(dashboardUrl)}
              iconName="ExternalLink"
              iconSize={12}
            />
          </div>
          <div className="flex items-center gap-1">
            <CopyLinkButton url={embedUrl} label="Embed" />
            <Button
              variant="ghost"
              size="xs"
              onClick={() => handleOpenLink(embedUrl)}
              iconName="ExternalLink"
              iconSize={12}
            />
          </div>
        </div>
      </td>
      <td className="data-table-cell">
        <CompanyActionsMenu
          company={company}
          onStatusToggle={onStatusToggle}
          onDuplicate={onDuplicate}
        />
      </td>
    </tr>
  );
};

export default CompanyTableRow;